import Col from 'client/components/Col';
import Container from 'client/components/Container';
import React from 'react';
import Row from 'client/components/Row';
import { Heading } from '@indeed/ifl-components';
import { useLocalizationContext } from 'client/context/LocalizationContext';

export const ApplicationError = (): React.JSX.Element => {
    const { gt } = useLocalizationContext();

    return (
        <main>
            <Container>
                <Row>
                    <Col>
                        <Heading level={4}>
                            <strong>{gt.gettext('An error has occurred.')}</strong>
                        </Heading>
                    </Col>
                </Row>
                <Row>
                    <Col>{gt.gettext('Please come back and try again later.')}</Col>
                </Row>
            </Container>
        </main>
    );
};

export default ApplicationError;
